import { CommonButton } from 'components/Buttons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import services from 'services';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { actionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

const AssignDocumentLatency = () => {
  const idProgram = useSelector(selectors.app.getProgramCode);
  const protocols = useSelector(selectors.documents.selectAllActiveDocumentsID);
  const records = useSelector(selectors.documents.selectAllActiveDocuments);

  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();
  const { checkDocuments } = useCheckBeforeAction(actionType.ASSIGN_DOCUMENT_LATENCY);
  const onClick = async () => {
    const docFree = await checkDocuments();
    if (!docFree) return;
    try {
      await services.reassignDocumentLatency({ protocols, idProgram });
      dispatch(actions.documents.removeRows(protocols));
      utils.app.notify('success', t('assign_document_latency_success'));
    } catch (e) {
      console.error(e);
      utils.app.notify('fail', e as Error);
    }
  };
  return (
    <CommonButton
      id="assign-document-latency-btn"
      action={onClick}
      disabled={!utils.user.isActionEnabled(records, actionType.ASSIGN_DOCUMENT_LATENCY)}
      scope="tertiary"
      value={t('reassign_document_latency')}
      customIcon="write"
    />
  );
};

export default AssignDocumentLatency;
